module.exports = __webpack_public_path__ + "static/media/course_1-alt.fe3a7e96.mp4";